import { Divider } from "antd";
import Check from "@/app/assets/common/Check.svg";
import Error from "@/app/assets/common/Error.svg";

export type CustomStepsProps = {
  errorIndex: number;
  current?: number;
  items?: Array<{ title: string }>;
};

export const enum StepsStatus {
  SUBMIT_APPLICATION = "Submit Application",
  REVIEW = "Review",
  CONFIRM_PRODUCT = "Confirm Product",
  REFUND = "Refund",
  COMPLETE = "Complete",
}

export const StepsBase = [
  {
    title: StepsStatus.SUBMIT_APPLICATION,
  },
  {
    title: StepsStatus.REVIEW,
  },
  {
    title: StepsStatus.CONFIRM_PRODUCT,
  },
  {
    title: StepsStatus.REFUND,
  },
  {
    title: StepsStatus.COMPLETE,
  },
];

export const CustomSteps: React.FC<CustomStepsProps> = ({
  current = 2,
  items = StepsBase,
  errorIndex,
  ...props
}) => {
  // 失败的话需要红色线条加Warning.svg
  const _renderDot = (index: number) => {
    if (index < current) {
      if (errorIndex === index) {
        return <Error width={24} />;
      }

      return <Check width={24} />;
    } else if (index === current) {
      return (
        <div className="h-24 w-24 rounded-full border-2 border-bravve-100" />
      );
    } else {
      return (
        <div className="h-24 w-24 rounded-full border-2 border-bravve-line-100" />
      );
    }
  };

  return (
    <div className="flex w-full">
      {items.map((item, index) => {
        return (
          <div key={index} className={`flex flex-1`}>
            <div className="flex w-full flex-col items-center">
              <div
                className="flex w-full"
                style={{ marginLeft: index === 4 ? 72 : "calc(100% - 24px)" }}
              >
                <div>{_renderDot(index)}</div>
                {index !== items.length - 1 && (
                  <div
                    className={`mx-8 ${items.length === 5 ? "w-72" : "w-full"}`}
                  >
                    <Divider
                      dashed={errorIndex > 0 ? false : current === index + 1}
                      style={{
                        marginTop: 12,
                        marginBottom: 0,
                        height: 2,
                        borderWidth: 1,
                        borderColor:
                          errorIndex > 0
                            ? "#C31010"
                            : current > index
                              ? "#402C22"
                              : "#C6C0BD",
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="mt-4 text-center w-60">{item.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
